const permissions = {
  // Admin permissions
  ADMINISTRATE_API_INTEGRATIONS: 'administrate:api-integrations',
  ADMINISTRATE_ROUTING: 'administrate:routing',
  COBLER_ADMIN: 'cobler:admin',

  // Basic permissions
  BASIC_PERMISSION: 'basic:permission',

  // Camera permissions
  REQUEST_CAMERA_MEDIA: 'request:camera-media',

  // Config permissions
  CONFIG_AND_VIEW_CUSTOM_ALERTS: 'config-and-view:custom-alerts',
  CONFIG_FUEL_CARD: 'config:fuel-card',

  // Create/Update/Delete permissions
  CREATE_UPDATE_DELETE_CRM: 'create-update-delete:crm',
  CREATE_UPDATE_DELETE_DRIVER: 'create-update-delete:driver',
  CREATE_UPDATE_DELETE_PLACES_OF_INTEREST: 'create-update-delete:places-of-interest',
  CREATE_UPDATE_DELETE_ROUTES: 'create-update-delete:routes',
  CREATE_UPDATE_DELETE_USERS_AND_INVITES: 'create-update-delete:users-and-invites',
  CREATE_UPDATE_DELETE_VEHICLE: 'create-update-delete:vehicle',

  // Fleet permissions
  WRITE_FLEET_SAFETY: 'write:fleet-safety',

  // Fleet expenses permissions
  VIEW_FLEET_EXPENSES: 'view:fleet-expenses',
  WRITE_FLEET_EXPENSES: 'write:fleet-expenses',

  // Full control permissions
  FULL_CONTROL_CHECKLIST: 'full-control:checklist',
  FULL_CONTROL_MAINTENANCE: 'full-control:maintenance',

  // Hubspot permissions
  READ_HUBSPOT_CONTRACTS: 'read:hubspot-contracts',
  WRITE_HUBSPOT_FINANCE: 'write:hubspot-finance',

  // Update permissions
  UPDATE_DRIVER_FACE_CLUSTER: 'update:driver-face-cluster',
  UPDATE_FLEET_INFO: 'update:fleet-info',

  // Vehicle permissions
  BLOCK_VEHICLE: 'block:vehicle',

  // View Pages permissions
  VIEW_ANALYTICS_AND_REPORTS: 'view:analytics-and-reports',
  VIEW_CAMERA_MEDIA: 'view:camera-media',
  VIEW_FLEET_SAFETY: 'view:fleet-safety',
  VIEW_FUEL_CARD: 'view:fuel-card',
  VIEW_PLACES_OF_INTEREST: 'view:places-of-interest',
  VIEW_PROOF_OF_CONCLUSION: 'view:proof-of-conclusion',
  VIEW_ROUTES: 'view:routes',
  VIEW_USERS_AND_INVITES: 'view:users-and-invites',
} as const;

type Permission = (typeof permissions)[keyof typeof permissions];

/**
 * União (OR) das permissões das etapas do Guia de configuração (AE-2446): a página/sidebar/menu
 * ficam visíveis para quem pode executar pelo menos uma etapa. A fonte por-item é MATURITY_ITEMS
 * (modules/hooks/src/useBasicValueMaturity/basicValueMaturityModel.ts) — um drift test lá garante
 * que esta união declarada continua igual ao conjunto das permissões dos itens.
 */
const BASIC_VALUE_STEP_PERMISSIONS: Permission[] = [
  permissions.CREATE_UPDATE_DELETE_CRM,
  permissions.CREATE_UPDATE_DELETE_VEHICLE,
  permissions.CREATE_UPDATE_DELETE_DRIVER,
  permissions.CREATE_UPDATE_DELETE_USERS_AND_INVITES,
  permissions.CONFIG_AND_VIEW_CUSTOM_ALERTS,
  permissions.CREATE_UPDATE_DELETE_PLACES_OF_INTEREST,
  permissions.FULL_CONTROL_CHECKLIST,
];

export type { Permission };
export { BASIC_VALUE_STEP_PERMISSIONS, permissions };
